import { useDispatch } from 'react-redux'
import { invalidateDirectoryKolFootprintAction } from '@/api/workspace-api/directory-api'
import { setFootprintPage } from '@/store/kol-cooperation-detail-drawer'

/**
 * @deprecated Remove when useFetchInfiniteKolFootprintQuery refactor to native infinite queries
 */
const useResetCurrentFootprintPage = (): (() => void) => {
  const dispatch = useDispatch()

  return (): void => {
    dispatch(setFootprintPage(undefined))
    dispatch(invalidateDirectoryKolFootprintAction)
  }
}

export default useResetCurrentFootprintPage
